const d3 = Object.assign(
    {},
    require("d3-selection"),
    require("d3-zoom"),
    require("d3-drag"),
    require("d3-transition")
)

import getDimensions from "./d3-color-dimenions"

export default function drawBase() {
    
    this.dimensions = getDimensions(this.DOMtarget)
    // Two contexts #dots #voronoi

    this.canvasVoronoi = d3
        .select(`#${this.DOMtarget}`)
        .append("canvas")
        .attr("id", "canvasVoronoi")
        .attr("class", "canvas")
        .attr("width", this.dimensions.width)
        .attr("height", this.dimensions.height)
        .style("display", "none")

    this.canvasHighlight = d3
        .select(`#${this.DOMtarget}`)
        .append("canvas")
        .attr("id", "canvasHighlight")
        .attr("width", this.dimensions.width)
        .attr("height", this.dimensions.height)
        .attr("class", "canvas")

    this.canvas = d3
        .select(`#${this.DOMtarget}`)
        .append("canvas")
        .attr("id", "canvas")
        .attr("width", this.dimensions.width)
        .attr("height", this.dimensions.height)
        // .style("display", "none")

    this.context = this.canvas.node().getContext("2d")
    this.contextVoronoi = this.canvasVoronoi.node().getContext("2d")
    this.contextHighlight = this.canvasHighlight.node().getContext("2d")

    d3.select("#canvas").call(
        d3
            .zoom()
            .scaleExtent([0.2, 8]) //0.10/ 20
            .on("zoom", zoomed)
    )

    const ctx = this

    function zoomed() {
        // change position and scale
        d3.getEvent = () => require("d3-selection").event
        ctx.transform = d3.getEvent().transform
        ctx.scale = ctx.transform.k

        // console.log(ctx.scale)
        // console.log(ctx.transform)
        ctx.drawHighlight(ctx, ctx.currentDot, false)
        ctx.draw(ctx)

        ctx.hideToolTip()
    }
}
